import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

import classes from "./SavingIndicator.module.less";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface Props {
  saving: boolean;
  className?: string;
}

export const SavingIndicator = ({ saving, className }: Props) => {
  const { t } = useTranslation();

  if (saving) {
    return (
      <div className={classNames(className, classes.root)}>
        <CircleSpinner className={classes.icon} />
        <span className={classes.savingText}>{t("generic.saving.inProgress")}</span>
      </div>
    );
  } else {
    return (
      <div className={classNames(className, classes.root)}>
        <Icon type={IconType.Check} className={classes.icon} />
        <span className={classes.savedText}>{t("generic.saving.done")}</span>
      </div>
    );
  }
};
